module.exports = __webpack_public_path__ + "/login_ui/img/ne-cb75972c238be4087fdc24c24317184a.svg";